import { actionCreator } from '@blink/components/src/utils';

import {
    GET_TOKENS,
    SET_AGREEMENT_TOKENS,
    SET_TOKENS,
    SET_TOKENS_LOADING_FALSE,
    SET_VAULT_TOKENS,
} from './constants';

import { Token } from '@/shared/api/borrow';

export const getTokensAction = () => actionCreator(GET_TOKENS);

export const setAgreementTokensAction = (payload: Token[]) =>
    actionCreator(SET_AGREEMENT_TOKENS, payload);

export const setVaultTokensAction = (payload: Token[]) => actionCreator(SET_VAULT_TOKENS, payload);

export const setTokensAction = (payload: Token[]) => actionCreator(SET_TOKENS, payload);

export const setTokensLoadingFalseAction = () => actionCreator(SET_TOKENS_LOADING_FALSE);
